import { SHARE_CARD_TIER } from "./triviaShareCardTiers";

export const SHARE_CARD_LAB_PRESETS = [
  {
    id: "daily-teal",
    label: "Daily 8/10 — teal",
    card: {
      mode: "daily",
      grade: "B",
      correct: 8,
      total: 10,
      score: 720,
      sportLabel: "MLB",
      username: "james",
      shareToken: "previewDailyTeal",
      tier: "",
    },
  },
  {
    id: "daily-gold",
    label: "Daily 10/10 — gold",
    card: {
      mode: "daily",
      grade: "A",
      correct: 10,
      total: 10,
      score: 1170,
      sportLabel: "MLB",
      username: "james",
      shareToken: "previewDailyGold",
      tier: "",
    },
  },
  {
    id: "quick-teal",
    label: "Quick 3/5 — teal",
    card: {
      mode: "quick",
      grade: "C",
      correct: 3,
      total: 5,
      score: 210,
      sportLabel: "NBA",
      username: "james",
      shareToken: "previewQuickTeal",
      tier: "",
    },
  },
  {
    id: "force-gold",
    label: "Force gold on a B",
    card: {
      mode: "daily",
      grade: "B",
      correct: 7,
      total: 10,
      score: 640,
      sportLabel: "NFL",
      username: "james",
      shareToken: "previewForceGold",
      tier: SHARE_CARD_TIER.GOLD,
    },
  },
];

export function labDraftFromPreset(preset) {
  return { ...preset.card };
}

export const SHOWCASE_CARDS = {
  teal: {
    ...SHARE_CARD_LAB_PRESETS[0].card,
    username: "you",
    shareToken: "showcaseDailyTeal",
  },
  gold: {
    ...SHARE_CARD_LAB_PRESETS[1].card,
    username: "you",
    shareToken: "showcaseDailyGold",
  },
};
